//Warning message when deleting a page
//on the Site Settings
function toDelete(event) {
	event = event || window.event || new Event("click");

	var button = event.target || event.explicitOriginalTarget;
	var page = button.dataset.page;
	var url = button.dataset.href;
	var quest;
	var text = button.dataset.title || 'Do you really want to delete element "';

	quest = confirm(text + page + '"?');

	if(quest == true) {
		location.href = url;
	}
};
